import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Loader2 from '@/components/brand/Loader2';
import LegalText from '../components/legal/LegalText';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Legal — página pública de un documento legal vigente.
 * `docType`: 'terms' (Términos y Condiciones) o 'privacy' (Aviso de Privacidad).
 */
const Legal = ({ docType }) => {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let ignore = false;
    setDoc(null);
    setError(false);
    axios.get(`${API}/legal/${docType}`)
      .then((res) => { if (!ignore) setDoc(res.data); })
      .catch(() => { if (!ignore) setError(true); });
    return () => { ignore = true; };
  }, [docType]);

  return (
    <div className="min-h-screen bg-zinc-950 py-10 px-4">
      <div className="w-full max-w-3xl mx-auto">
        <div className="flex items-center justify-between gap-4 mb-8">
          <Link to="/" className="flex items-center gap-3">
            <img src="/brand/app-icon-square.webp" alt="Onor Code" className="h-10 w-10 rounded" />
            <span className="font-teko text-2xl text-white tracking-wider">[ONOR] CODE</span>
          </Link>
          <nav className="flex gap-4 text-xs">
            <Link
              to="/terminos"
              className={docType === 'terms' ? 'text-primary' : 'text-zinc-400 hover:text-white'}
            >
              Términos y Condiciones
            </Link>
            <Link
              to="/privacidad"
              className={docType === 'privacy' ? 'text-primary' : 'text-zinc-400 hover:text-white'}
            >
              Aviso de Privacidad
            </Link>
          </nav>
        </div>

        {error && (
          <p className="text-zinc-400 text-sm" role="alert">
            No pudimos cargar el documento. Intenta de nuevo en unos minutos.
          </p>
        )}
        {!doc && !error && (
          <div className="flex items-center gap-2 text-zinc-400 text-sm">
            <Loader2 className="w-4 h-4 animate-spin" /> Cargando…
          </div>
        )}
        {doc && (
          <>
            <LegalText content={doc.content} />
            <p className="text-zinc-600 text-xs mt-10 border-t border-zinc-800 pt-4">
              Versión {doc.version} · publicada el{' '}
              {new Date(doc.published_at).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Legal;
